const STATUS_DELIVERED = 'delivered';
const STATUS_PREPARING = 'preparing';
const STATUS_CANCELLED = 'cancelled';

export { STATUS_DELIVERED, STATUS_PREPARING, STATUS_CANCELLED };
